export default __webpack_public_path__ + "static/media/error.364b162c.png";